// @flow

import React from "react";

type Props = {
  height?: number,
  width?: number,
  color?: string
};

const Up = ({
  color = "black",
  height = 24,
  width = 24,
  ...restProps
}: Props) => (
  <svg
    width={width}
    height={height}
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...restProps}
  >
    <path d="M17 15L12 10L7 15L17 15Z" fill={color} />
  </svg>
);

export default Up;
